// @ts-nocheck
import React from 'react';
import NotAvailableYet from '../components/NotAvailableYet';

// Rosters are owned by RecruitLook; RLE has no coach roster table to read.
interface TeamDetailScreenProps {
  registrationId: string;
  teamId?: string;
  teamName: string;
  division?: string;
  status: string;
  coachInfo?: { name?: string; email?: string; phone?: string };
  onBack: () => void;
}

const TeamDetailScreen: React.FC<TeamDetailScreenProps> = ({ teamName, onBack }) => (
  <NotAvailableYet
    onBack={onBack}
    message={`Team rosters${teamName ? ` for ${teamName}` : ''} are not available in the app yet.`}
  />
);

export default TeamDetailScreen;
